import type { FullName } from '~/core/types'
import { masterClient } from '~/core/utils/clients/masterClient'
import { infoClient } from '~/core/utils/clients/infoClient'
import { profileClient } from '~/core/utils/clients/profileClient'
import type { FamilyProfileOwnership } from '~/core/enums/family'
import type { EsiaStatus, Gender } from '~/features/Profile/enums'

const RESOURCE = '/profile/family_profiles/'

export type FamilyListFromProfileDto = FullName & {
  masterFamilyProfileUuid: string
  gender: Gender
}

export type FamilyListFromMasterDto = {
  uuid: string
  dtBirth: DateISO | null // В случае, если есть неподтвержденный документ, бек не присылает dtBirth для семейного профиля
  isMain: true
  avatarType: string
  ageGroup: string
  esiaInfo: {
    status: EsiaStatus
    date: DateTimeISO
  }
  newPhone: string
  ownership?: FamilyProfileOwnership, // TODO[wff_cancel_transfer_dialog]: станет обязательным
  sharedInfo?: Omit<FamilyListFromProfileDto, 'masterFamilyProfileUuid'> | null // TODO[wff_family_profiles_transfer]: станет обязательным
}

export type FamilyListFromInfoDto = {
  masterFamilyProfileUuid: string
  dtMedformsUpdatedUtc: string | null
  femaleCalendarId: number | null
  hasDentalTreatmentPlan: boolean
  hasSignedEdmDocuments: boolean
}

export type FamilyProfileInfoDto = FullName & {
  dtBirth: DateISO
  gender: Gender
  isMain?: true
}

export type GetEsiaAuthorizationLinkPayload = {
  familyProfileUuid: string,
  appointmentId?: string,
  redirectUrl?: string,
}
export const familyApi = {
  getFamilyListFromMaster() {
    return masterClient.get<FamilyListFromMasterDto[]>(RESOURCE, { camelize: true })
  },
  getFamilyListFromInfo() {
    return infoClient.get<FamilyListFromInfoDto[]>(RESOURCE, { camelize: true })
  },
  getFamilyListFromProfile() {
    return profileClient.get<FamilyListFromProfileDto[]>(RESOURCE, { camelize: true })
  },
  createFamilyProfile(profile: FamilyProfileInfoDto) {
    return masterClient.post<{ uuid: string }>(`${RESOURCE}create/`, profile, {
      camelize: true,
    })
  },
  updateFamilyProfile(uuid: string, profile: FamilyProfileInfoDto) {
    return masterClient.patch(`${RESOURCE}update/`, profile, {
      camelize: true,
      headers: {
        'Family-Profile-Uuid': uuid,
      },
    })
  },
  deleteFamilyProfile(uuid: string) {
    return masterClient.post(`${RESOURCE}delete/`, {}, {
      camelize: true,
      headers: {
        'Family-Profile-Uuid': uuid,
      },
    })
  },
  mergeFamilyProfile(uuidSaveProfile: string, uuidDeleteProfile: string) {
    return masterClient.patch(`${RESOURCE}${uuidSaveProfile}/merge/${uuidDeleteProfile}/`)
  },
  getEsiaAuthorizationLink(payload: GetEsiaAuthorizationLinkPayload) {
    return masterClient.post<{ loginUrl: string }>(`${RESOURCE}${payload.familyProfileUuid}/esia_login/`,
      {
        appointmentId: payload.appointmentId,
        redirectUrl: payload.redirectUrl,
      },
      { camelize: true })
  },
}
